import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationError, Router, RouterStateSnapshot } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';
import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuardService {
  private readonly STORAGE_KEY = 'savedTargetUrl';
  redirectRoute: string = '/staff-dashboard';
  badCredentials = false;
  private targetUrl: string | null = null;

  constructor(
    private router: Router,
    private logger: NGXLogger
  ) {
    this.router.events.subscribe(e => {
      if (e instanceof NavigationError) {
        this.logger.error('Navigation error:', e.error);
      }
    });
  }

  isLoggedIn(): boolean {
    const token = localStorage.getItem('token');
    if (!token) { return false; }
    try {
      const { 'petszel-credentialtype': cred } = jwtDecode<any>(token);
      const types = Array.isArray(cred) ? cred : [cred];
      return types.includes('PetszelStaff') || types.includes('PetszelAdmin');
    } catch {
      return false;
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.isLoggedIn()) {
      return true;
    }

    localStorage.setItem(this.STORAGE_KEY, state.url);

    this.router.navigate(['/'], { queryParams: { redirect: state.url } });
    return false;
  }

  redirectCallback(credentialType: string|string[]) {
    const types = Array.isArray(credentialType) ? credentialType : [credentialType];
    if (!types.some(t => t === 'PetszelStaff' || t === 'PetszelAdmin')) {
      return;
    }

    const target = localStorage.getItem(this.STORAGE_KEY) ?? this.redirectRoute;
    localStorage.removeItem(this.STORAGE_KEY);

    this.router.navigateByUrl(target).catch(err =>
      this.logger.error('Failed redirect after login:', err)
    );
  }

  getTargetUrl(): string | null {
    return localStorage.getItem('savedTargetUrl');
  }

  setTargetUrl(url: string): void {
    this.targetUrl = url;
  }

    logoutAndRedirect(): Observable<void> {
    localStorage.removeItem('token');
    this.router.navigateByUrl('/');
    return of(undefined);
  }
}
